module.exports = __webpack_public_path__ + "img/skills-lightning-sor-2.7bd68cfb.png";